import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { TableNameE } from 'shared/api/types/common';
import PageTitle from 'shared/views/admin/PageTitle';
import { useGetColumns } from './constants';
import { useParams } from 'react-router-dom';
import { PathsParams, PathsE } from 'shared/routes';
import { useGetOneService } from 'shared/api/requests/services';
import Card from 'shared/components/horizon-ui/card/Card';
import DragableTable from 'shared/components/table/DragableTable';
import { useGetNewsService } from "shared/api/requests/news";
import { NewsDTO } from "shared/api/types/news";

const Index = () => {
  const { serviceId } = useParams<PathsParams[PathsE.NEWS]>();
  const { t } = useTranslation();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });

  const { useGetNews, useDeleteNews } = useGetNewsService({
    domain: currentService?.domain,
    token: currentService?.token,
  })

  const { mutate: deleteNews } = useDeleteNews();

  

  const handleDelete = (id: number) => {
    deleteNews({id: String(id)})
  };
  

  const onChangeOrder = (id: number, order: number) => {
    console.log('id', id);
    console.log('id', order);
  };

  const columns = useGetColumns({
    serviceId,
    handleDelete,
    isDeletePending: false,
  });
  
  return (
    <Box>
      <PageTitle title={"News"} />
      <Card borderRadius="20px" p="30px" shadow="md">
        <DragableTable<Omit<NewsDTO, 'order'>>
          query={useGetNews}
          onChangeOrder={onChangeOrder as FixMeLater}
          columns={columns as FixMeLater}
          filterFields={[]}
          tableName={TableNameE.NEWS}
          disableSearch
        />
      </Card>
    </Box >
  );
}

export default Index;
